// extracted by mini-css-extract-plugin
module.exports = {"container":"PreOrderConfigurationSummary_container__fserA"};